import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client"; 
import { HashRouter, Navigate, Routes, Route } from "react-router-dom";
import { Provider } from "components/ui/provider"
import "./main.css";
import AuthLayout from "layouts/Auth.js";
import MainLayout from "layouts/Main.js";
import PrivateRoute from "components/Routes/PrivateRoutes"
import AuthRoute from "components/Routes/AuthRoutes";

// Force light mode on app initialization
localStorage.setItem('chakra-ui-color-mode', 'light');

const root = ReactDOM.createRoot(document.getElementById("root")); 

root.render(
 
     <Provider  >
    
    <HashRouter>
      <Routes>
        <Route path="/auth/*" element={<AuthRoute><AuthLayout /></AuthRoute>} />
        <Route path="/main/*" element={<PrivateRoute><MainLayout /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    </HashRouter>
    </Provider>

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
